import type { ReactNode } from 'react';

import { Button } from '../../shared/ui/button';
import { CopyField } from '../../shared/ui/copy-field';
import { Hint } from '../../shared/ui/hint';
import { Modal } from '../../shared/ui/modal';

interface ISecretShownOnceProps {
  plaintext: string | null;
  clientName: string;
  onClose: () => void;
  /** What closing leads to, when it leads somewhere: "Open their page". */
  doneLabel?: string;
  children?: ReactNode;
}

// The server returns a generated secret once and keeps only a hint: closing this loses it for good.
export const SecretShownOnce = ({
  plaintext,
  clientName,
  onClose,
  doneLabel = 'Done',
  children,
}: ISecretShownOnceProps) => (
  <Modal
    open={plaintext !== null}
    onOpenChange={(open) => !open && onClose()}
    title={`${clientName}’s new secret`}
    description="Their address stays the same."
    footer={
      <Button size="sm" onClick={onClose}>
        {doneLabel}
      </Button>
    }
  >
    {children}
    <CopyField value={plaintext ?? ''} />
    <Hint>Shown once. Send it to {clientName}; they sign with it from now on.</Hint>
  </Modal>
);
